/**
 *
 *
 * NAVIGATION SCRIPT BY BUREAU BOMBIG
 *
 *
 */

/**
 *
 * Prevent Scrolling when Menu is open
 *
 */

document.addEventListener("DOMContentLoaded", function (e) {
  // left: 37, up: 38, right: 39, down: 40,
  // spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
  var keys = { 37: 1, 38: 1, 39: 1, 40: 1 };
  var scrollStatus = true;

  function preventDefault(e) {
    e.preventDefault();
  }

  function preventDefaultForScrollKeys(e) {
    if (keys[e.keyCode]) {
      preventDefault(e);
      return false;
    }
  }

  // modern Chrome requires { passive: false } when adding event
  var supportsPassive = false;
  try {
    window.addEventListener(
      "test",
      null,
      Object.defineProperty({}, "passive", {
        get: function () {
          supportsPassive = true;
        },
      })
    );
  } catch (e) {}

  var wheelOpt = supportsPassive ? { passive: false } : false;
  var wheelEvent = "onwheel" in document.createElement("div") ? "wheel" : "mousewheel";

  // call this to Disable
  function disableScroll() {
    window.addEventListener("DOMMouseScroll", preventDefault, false); // older FF
    window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
    window.addEventListener("touchmove", preventDefault, wheelOpt); // mobile
    window.addEventListener("keydown", preventDefaultForScrollKeys, false);
    scrollStatus = false;
  }

  // call this to Enable
  function enableScroll() {
    window.removeEventListener("DOMMouseScroll", preventDefault, false);
    window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
    window.removeEventListener("touchmove", preventDefault, wheelOpt);
    window.removeEventListener("keydown", preventDefaultForScrollKeys, false);
    scrollStatus = true;
  }

  /**
   *
   * Enable Fixed Menu on Scroll on Desktop
   *
   */

  window.onscroll = function () {
    if (window.innerWidth > 768) {
      fixMenuOnScroll();
    }
  };

  // Get the header
  const header = document.getElementById("bbHeaderContainer");
  const body = document.querySelector("body");

  // Get the offset position of the navbar
  const sticky = window.innerHeight / 2;

  // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
  function fixMenuOnScroll() {
    if (window.pageYOffset > sticky) {
      header.classList.add("bb-header-container-fixed");
    } else {
      header.classList.remove("bb-header-container-fixed");
    }
  }

  /**
   *
   * Enable Fullscreen Menu
   *
   */

  const bbNavFullscreen = document.getElementById("bbNavFullscreen");
  const bbNavBurger = document.getElementById("bbNavBurger");

  function toggleMenu() {
    bbNavFullscreen.classList.toggle("bb-fullscreen-active");

    // Prevent Scroll
    if (scrollStatus) {
      disableScroll();
    } else {
      enableScroll();
    }

    // Burger animation
    bbNavBurger.classList.toggle("bb-nav-burger-animation");
  }

  bbNavBurger.addEventListener("click", toggleMenu);
});

document.addEventListener("DOMContentLoaded", function () {
  const searchInputMobile = document.getElementById("bbFullscreenMobileSearch");
  const searchButtonMobile = document.getElementById("bbFullscreenMobileSearchButton");
  let currentUrl = new URL(window.location);
  let currentParams = new URLSearchParams(currentUrl.search);
  let langParam = "";

  if (currentParams.has("lang")) {
    langParam = "&lang=" + currentParams.get("lang");
  } else {
    langParam = "";
  }

  searchButtonMobile.addEventListener("click", function (event) {
    if (!searchInputMobile.value) {
      return;
    }

    window.location.href = `/archiv/?property%5B0%5D%5Bjoiner%5D=and&property%5B0%5D%5Bproperty%5D=&property%5B0%5D%5Btype%5D=in&property%5B0%5D%5Btext%5D=${searchInputMobile.value}${langParam}`;
  });
});
